import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { dictionariesAtom } from '../../state';
import { MarketDataProvider, NbDictionaries, TypeCategoryItem } from '../../types';

export const useDictionary = () => {
  const dictionaries = useAtomValue(dictionariesAtom);

  const formatDictionaryType = useCallback(
    (id: string, key: keyof NbDictionaries) => {
      return (
        dictionaries[key].find((dictionary: TypeCategoryItem | MarketDataProvider) => dictionary.id === id)?.name || id
      );
    },
    [dictionaries],
  );

  const getDictionary = useCallback(
    (key: keyof NbDictionaries) => {
      return dictionaries[key];
    },
    [dictionaries],
  );

  return {
    formatDictionaryType,
    getDictionary,
  };
};
